/* ============================================================================
   main.js
   ========================================================================= */

/**
 * Main script bundle used throughout the website
 *
 * @author: Mark Croxton, mcroxton@hallmark-design.co.uk
 * @copyright: Hallmark Design
 */

/* eslint-disable no-unused-vars */

// For HMR work, we have to import the CSS ¯\_(ツ)_/¯
import '../styles/main.scss';

// Initialise modules
import geteventlisteners from "./modules/geteventlisteners";
import HtmxInit from './modules/htmxInit';
import Start from './modules/start';
import PubSub from "pubsub-js";
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

// .no-js to .js
let html = document.getElementsByTagName("html")[0];
html.className = html.className.replace("no-js", "js");

// Initialise htmx
if (typeof htmx != "undefined") {
    new HtmxInit();
}

const start = new Start();

// Accept HMR
// https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
    module.hot.accept();
}
